import { createAsyncThunk } from "@reduxjs/toolkit";
import {UNKNOWN_ERROR} from "../messages/errorsMessages";

export const makeApiRequest = createAsyncThunk("apiRequest", async (func: () => Promise<any>) => {
  try {
    return await func();
  } catch (err) {
    return { isError: true, errorTable: err.name !== "AbortError" ? [UNKNOWN_ERROR] : [] };
  }
});
